"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Risk API
 * Risk Service API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateToJSON = exports.StateFromJSONTyped = exports.StateFromJSON = exports.State = void 0;
/**
 *
 * @export
 */
exports.State = {
    Inbox: 'inbox',
    Acknowledged: 'acknowledged',
    InProgress: 'in_progress',
    Accepted: 'accepted',
    FalsePositive: 'false_positive',
    Fixed: 'fixed',
    Mitigated: 'mitigated'
};
function StateFromJSON(json) {
    return StateFromJSONTyped(json, false);
}
exports.StateFromJSON = StateFromJSON;
function StateFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.StateFromJSONTyped = StateFromJSONTyped;
function StateToJSON(value) {
    return value;
}
exports.StateToJSON = StateToJSON;
